import { currency } from '@ecg-internal/aurora-js-formatters';
import type { I18nContextType } from '@ecg-marktplaats/js-react-i18n';
import { TListingPrice } from 'types/TListing';
import { priceTypes } from '../../../common/constants';

const { FIXED, MIN_BID } = priceTypes;

/**
 * Formats price name or monetary value
 * Ported from @ecg-marktplaats/aurora-templates/src/helpers/formatPrice.js
 */
export default (
  price: TListingPrice,
  isReserved: boolean,
  t: I18nContextType['t'],
  suppressZeroCents: boolean = false,
): string => {
  if (isReserved) {
    return t('priceTypes:prices.RESERVED');
  }
  const { priceCents, priceType } = price;
  const hasMonetaryValue = [FIXED, MIN_BID].includes(priceType);

  return hasMonetaryValue ? currency(priceCents, true, suppressZeroCents) : t(`priceTypes:prices.${priceType}`);
};
